import e from "./index27.js";
import t from "./index28.js";
import n from "./index29.js";
import r from "./index30.js";
import i from "./index38.js";
import a from "./index44.js";
import o from "./index45.js";
import s from "./index46.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/createTheme/createTheme.js
function c(c = {}, ...l) {
	let { breakpoints: u = {}, palette: d = {}, spacing: f, shape: p = {}, ...m } = c, h = t(u), g = i(f), _ = e({
		breakpoints: h,
		direction: "ltr",
		components: {},
		palette: {
			mode: "light",
			...d
		},
		spacing: g,
		shape: {
			...r,
			...p
		}
	}, m);
	return _ = n(_), _.applyStyles = s, _ = l.reduce((t, n) => e(t, n), _), _.unstable_sxConfig = {
		...a,
		...m?.unstable_sxConfig
	}, _.unstable_sx = function(e) {
		return o({
			sx: e,
			theme: this
		});
	}, _;
}
//#endregion
export { c as default };

//# sourceMappingURL=index47.js.map